import { NgModule } from '@angular/core';
import { NbspRemovePipe } from '../../pipes/nbsp-remove.pipe';

@NgModule({
  declarations: [NbspRemovePipe],
  exports: [NbspRemovePipe],
  providers: [NbspRemovePipe],
})
export class NbspRemoveModule {}
